import { ContentReference } from '@oneaudi/falcon-tools';
import {
  DatePatternType,
  FinanceOptionType,
  PatternType,
  SortOption,
} from '@oneaudi/vtp-configuration-service';
import { OneCMSContent } from '../types/oneCMS';
import React from 'react';

export type AppContextForThisInstance = 'results' | 'favorites';
export interface TileContextState {
  appContext: AppContextForThisInstance;
  contentConfiguration: PlpConfiguration;
}
export interface PlpConfiguration extends OneCMSContent {
  appContext: AppContextForThisInstance;
  detailsPageUrlPattern: string;
  newSearchUrl: string;
  vtpConfiguration: { fields: oneCMSVtpConfiguration };
}
export interface oneCMSVtpConfiguration {
  scopes_iframeForms: boolean;
  scopes_financeEnabled: boolean;
  scopes_financeOption: FinanceOptionType;
  scopes_interpretDisclaimersTextStyle: boolean;
  scopes_hideCalculationDisclaimer: boolean;
  scopes_hideRateChangeCTA: boolean;
  scopes_hideFinanceForEcom: boolean;
  scopes_forcePhoneAsPrimary: boolean;
  scopes_phoneWithNumber: boolean;
  cta: any[];
  urls_scStartPageLink: string;
  urls_eecImageUrl: string;
  urls_warrantyPlusLogoURL: string;
  assets_warrantyPlusLogo: ContentReference;
  infoLayerLinks: any[];
  consumptionEmission_tilesEmissionRepresentation: ['wltp'];
  consumptionEmission_consumptionEmissionRepresentation: ['wltp'];
  useEfficiencyImage: boolean;
  financeLayer_hideFinanceTable: boolean;
  financeLayer_disclaimerListItems: [];
  scs_scsMarketPath: string;
  warrantyTechDataItems: [];
  sortParams_options: SortOption[];
  sortParams_defaultOption: string;
  currency?: string;
  currencyPattern: PatternType;
  datePattern?: DatePatternType;
  consumptionEmission?: any;
  scContextId?: string;
  notFound?: string | { path: string };
  overWriteSorting_filterToTriggerSorting: string;
  overWriteSorting_overrideDefaultSortingKey: string;
  enableMyAudiWishlist: boolean;
  myAudiWishlist?: { path: string };
}

export const TileContext = React.createContext<TileContextState>({
  appContext: 'results',
  contentConfiguration: {} as PlpConfiguration,
});

export function getAppContext() {
  const context = React.useContext(TileContext);
  return context.appContext;
}
export function getAppContentConfiguration() {
  const context = React.useContext(TileContext);
  return context.contentConfiguration;
}
